import { render, staticRenderFns } from "./PetitionDetail.vue?vue&type=template&id=42e40923&scoped=true&"
import script from "./PetitionDetail.vue?vue&type=script&lang=js&"
export * from "./PetitionDetail.vue?vue&type=script&lang=js&"
import style1 from "./PetitionDetail.vue?vue&type=style&index=1&id=42e40923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e40923",
  null
  
)

export default component.exports